module.exports = __webpack_public_path__ + "__static/site-1783523783704/img/weasel.7a358037.png";